import React, { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import CoApplicantNamesTable from "./CoApplicantNamesTable";
import loadConfig from "../../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import { GetAllAI_ApplicantType } from "../../../Redux/Reducers/DropDownApplicationInformation";
import {
  GetBeneficiaryInformation,
  SetBeneficiaryInformation,
} from "../../../Redux/Reducers/BeneficiaryInformation";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const BeneficiaryInformation = (props) => {
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      BeneficiaryInformation:
        state.BeneficiaryInformation.BeneficiaryInformation,
      BeneficiaryInformationLoading:
        state.BeneficiaryInformation.loadingBeneficiaryInformation,
      AI_ApplicantType: state.dropDownApplicationInformation.AI_ApplicantType,
      ApplicationInformationValidationPage:
        state.ApplicationInformationValidationPage
          .ApplicationInformationValidationPage,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });

  const [BeneficiaryInformation, setBeneficiaryInformation] = useState({
    ...state.BeneficiaryInformation,
  });
  const [showAsterisk, setshowAsterisk] = useState(false);
  //[,]
  //to get data by giud from localstoreg or params
  useEffect(() => {
    dispatch(GetAllAI_ApplicantType());
    dispatch(
      GetBeneficiaryInformation(
        localStorage.getItem("aI_ApplicationInformationId") ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);
  //[,]
  //to assigin data on state after loding ends
  useEffect(() => {
    if (!state.BeneficiaryInformationLoading) {
      setBeneficiaryInformation({ ...state.BeneficiaryInformation });
    }
  }, [state.BeneficiaryInformationLoading]);
  //[,]
  //to assigin data on reducer after any  change on BeneficiaryInformation state
  useEffect(() => {
    dispatch(SetBeneficiaryInformation({ ...BeneficiaryInformation }));
  }, [BeneficiaryInformation]);
  //console.log(state.BeneficiaryInformation, "BeneficiaryInfordcasdasdsmation");
  let shouldDisableFields=""
console.log(state.ApplicationInformation?.aI_ApplicationStatusId,"ssssssssdwdwdwd");

  if(state.ApplicationInformation?.aI_ApplicationStatusId){
shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  }
   console.log(shouldDisableFields,"ssssssssssssdwdwd");
   
console.log(state.ApplicationInformation?.aI_ApplicationStatusId,"ssssssdswdsssssdwdwd");

  //[,]
  // لافراغ الحقول عند التغيير على نوع المستفيد
  useEffect(() => {
    if (
      state.BeneficiaryInformation.aI_ApplicantTypeId !== 3 &&
      state.BeneficiaryInformation.aI_ApplicantTypeId !== 4
    ) {
      setBeneficiaryInformation((prev) => ({
        ...prev,
        typeOfLegalRegistration: null,
        registrationNumber: null,
      }));
    }

    if (state.BeneficiaryInformation.aI_ApplicantTypeId == 1) {
      setshowAsterisk(true);
    } else {
      setshowAsterisk(false);
    }
  }, [state.BeneficiaryInformation.aI_ApplicantTypeId]);

  return !state.BeneficiaryInformationLoading ? (
    <>
      <div className="form-grid">
        <AllDropDownsAHSF
          fieldsName="applicantType"
          show={true}
          disabled={shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.AI_ApplicantType}
          KeyText={"aI_ApplicantTypeAr"}
          KeyValue={"aI_ApplicantTypeId"}
          defaultValue={state.BeneficiaryInformation?.aI_ApplicantTypeId}
          onChange={(e) => {
            setBeneficiaryInformation({
              ...BeneficiaryInformation,
              aI_ApplicantTypeId: parseInt(e.target.value), // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "applicantType"
                )
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />

        <InputAHSF
          fieldsName="NameOfTheEntity"
          show={true}
          disabled={shouldDisableFields}
          showAsterisk={showAsterisk}
          defaultValue={state.BeneficiaryInformation?.entityName}
          onChange={(e) => {
            setBeneficiaryInformation({
              ...BeneficiaryInformation,
              entityName: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "NameOfTheEntity"
                )
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="NatureOfEntityWork"
          show={true}
          disabled={shouldDisableFields}
          showAsterisk={showAsterisk}
          defaultValue={state.BeneficiaryInformation?.entitiesNatureOfWork}
          onChange={(e) => {
            setBeneficiaryInformation({
              ...BeneficiaryInformation,
              entitiesNatureOfWork: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "NatureOfEntityWork"
                )
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        {state.BeneficiaryInformation.aI_ApplicantTypeId == 3 ||
        state.BeneficiaryInformation.aI_ApplicantTypeId == 4 ? (
          <>
            <InputAHSF
              fieldsName="LegalRegistrationType"
              show={true}
              disabled={shouldDisableFields}
              defaultValue={
                state.BeneficiaryInformation?.typeOfLegalRegistration
              }
              onChange={(e) => {
                setBeneficiaryInformation({
                  ...BeneficiaryInformation,
                  typeOfLegalRegistration: e.target.value, // التحديث هنا
                });
              }}
              showValidationMessage={
                state.ApplicationInformationValidationPage
                  ? state.ApplicationInformationValidationPage.includes(
                      "LegalRegistrationType"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="LegalRegistrationNumber"
              show={true}
              disabled={shouldDisableFields}
              defaultValue={state.BeneficiaryInformation?.registrationNumber}
              onChange={(e) => {
                setBeneficiaryInformation({
                  ...BeneficiaryInformation,
                  registrationNumber: e.target.value, // التحديث هنا
                });
              }}
              showValidationMessage={
                state.ApplicationInformationValidationPage
                  ? state.ApplicationInformationValidationPage.includes(
                      "LegalRegistrationNumber"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </>
        ) : (
          ""
        )}
        <InputAHSF
          fieldsName="Website"
          show={true}
          disabled={shouldDisableFields}
          defaultValue={state.BeneficiaryInformation?.website}
          onChange={(e) => {
            setBeneficiaryInformation({
              ...BeneficiaryInformation,
              website: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes("Website")
              : false
          }
        />
        <InputAHSF
          fieldsName="LandlineNumberOfTheEntity"
          type="number"
          show={true}
          disabled={shouldDisableFields}
          defaultValue={state.BeneficiaryInformation?.entityTelephoneNumber}
          onChange={(e) => {
            setBeneficiaryInformation({
              ...BeneficiaryInformation,
              entityTelephoneNumber: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "LandlineNumberOfTheEntity"
                )
              : false
          }
        />
        <InputAHSF
          fieldsName="EmailOfTheEntity"
          show={true}
          type={"email"}
          disabled={shouldDisableFields}
          defaultValue={state.BeneficiaryInformation?.entityEmail}
          onChange={(e) => {
            setBeneficiaryInformation({
              ...BeneficiaryInformation,
              entityEmail: e.target.value, // التحديث هنا
            });
          }}
        />
      </div>
      <CoApplicantNamesTable
        aI_BeneficiaryInformationId={
          state.BeneficiaryInformation?.aI_BeneficiaryInformationId
        }
      />
    </>
  ) : (
    ""
  );
};

export default BeneficiaryInformation;
